import { render, staticRenderFns } from "./InfoBanner.vue?vue&type=template&id=f4844b84&scoped=true&"
import script from "./InfoBanner.vue?vue&type=script&lang=js&"
export * from "./InfoBanner.vue?vue&type=script&lang=js&"
import style0 from "./InfoBanner.vue?vue&type=style&index=0&id=f4844b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4844b84",
  null
  
)

export default component.exports